import React, { FC, ReactNode } from 'react'
import styled from 'styled-components'

const StyledCardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(27rem, 1fr));
  gap: 2.5rem;
  width: 100%;
`

export interface ICardGridProps {
  children: ReactNode
  className?: string
}

export const CardGrid: FC<ICardGridProps> = ({
  children,
  className,
}: ICardGridProps): JSX.Element => {
  return <StyledCardGrid className={className}>{children}</StyledCardGrid>
}
